import { HTMLProps } from 'react';
import cx from 'classnames';

import styles from './Divider.module.scss';

export type DividerProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & { text?: string };

const Divider = ({ className, text }: DividerProps): JSX.Element => {
  const renderCenterText = () => {
    if (text) {
      return <div className={styles.center}>{text}</div>;
    }

    return null;
  };

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.line} />
      {renderCenterText()}
      <div className={styles.line} />
    </div>
  );
};

export default Divider;
